import * as React from 'react';
import { ArticleParagraph1, InputAdornment } from '@cian/ui-kit';

import { FormInputsLayout } from '../FormInputsLayout';

export interface IRangeQuestionProps {
  unit?: React.ReactNode | null;
  gteValue: string;
  gteError?: string;
  gtePlaceholder: string;
  lteValue: string;
  ltePlaceholder: string;
  lteError?: string;
  lteInputName: string;
  gteInputName: string;

  handleChange(e: React.ChangeEvent<HTMLInputElement>): void;
}

export const RangeQuestion: React.FC<React.PropsWithChildren<IRangeQuestionProps>> = props => {
  const {
    unit,
    gteValue,
    lteValue,
    gteError,
    lteError,
    handleChange,
    gtePlaceholder,
    ltePlaceholder,
    lteInputName,
    gteInputName,
  } = props;
  const gteRef = React.useRef<HTMLInputElement>(null);
  const lteRef = React.useRef<HTMLInputElement>(null);

  const handleGteEnhancerClick = React.useCallback(() => {
    /* istanbul ignore else */
    if (gteRef.current) {
      gteRef.current.focus();
    }
  }, [gteRef]);
  const handleLteEnhancerClick = React.useCallback(() => {
    /* istanbul ignore else */
    if (lteRef.current) {
      lteRef.current.focus();
    }
  }, [lteRef]);

  return (
    <FormInputsLayout
      InputProps={{
        errorMessage: gteError,
        invalid: !!gteError,
        name: 'gte',
        type: 'text',
        inputRef: gteRef,
        onChange: handleChange,
        rightAdornment: <InputAdornment>{unit}</InputAdornment>,
        leftAdornment: (
          <InputAdornment>
            <ArticleParagraph1 onClick={handleGteEnhancerClick} color="text-primary-disabled" userSelect="none">
              {gtePlaceholder}
            </ArticleParagraph1>
          </InputAdornment>
        ),
        value: gteValue,
        'data-testid': gteInputName,
      }}
      secondInputProps={{
        errorMessage: lteError,
        invalid: !!lteError,
        name: 'lte',
        type: 'text',
        inputRef: lteRef,
        onChange: handleChange,
        rightAdornment: <InputAdornment>{unit}</InputAdornment>,
        leftAdornment: (
          <InputAdornment>
            <ArticleParagraph1 onClick={handleLteEnhancerClick} color="text-primary-disabled" userSelect="none">
              {ltePlaceholder}
            </ArticleParagraph1>
          </InputAdornment>
        ),
        value: lteValue,
        'data-testid': lteInputName,
      }}
    />
  );
};

RangeQuestion.displayName = 'RangeQuestion';
